import { APP_PDC_URL } from "../../../config";

import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const draftsConstants = {
  CREATE_DRAFT_ASK_START: "CREATE_DRAFT_ASK_START",
  CREATE_DRAFT_ASK_SUCCESS: "CREATE_DRAFT_ASK_SUCCESS",
  CREATE_DRAFT_ASK_ERROR: "CREATE_DRAFT_ASK_ERROR",

  GET_DRAFT_ASK_START: "GET_DRAFT_ASK_START",
  GET_DRAFT_ASK_SUCCESS: "GET_DRAFT_ASK_SUCCESS",
  GET_DRAFT_ASK_ERROR: "GET_DRAFT_ASK_ERROR",

  DELETE_DRAFT_ASK_START: "DELETE_DRAFT_ASK_START",
  DELETE_DRAFT_ASK_SUCCESS: "DELETE_DRAFT_ASK_SUCCESS",
  DELETE_DRAFT_ASK_ERROR: "DELETE_DRAFT_ASK_ERROR"
};

export function createDraftAsk(draftId,
  bodyRequest) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }

    return new Promise((resolve, reject) => {
      let request = {
        method: draftId ? "PUT" : "POST",
        url:
          APP_PDC_URL +
          "/api/v1/surveys/drafts" +
          (draftId ? `/${draftId}` : ""),
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: bodyRequest
      };

      dispatch({
        type: draftsConstants.CREATE_DRAFT_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: draftsConstants.CREATE_DRAFT_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: draftsConstants.CREATE_DRAFT_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: draftsConstants.CREATE_DRAFT_ASK_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function getDraftAsk(id) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    const companyUuidSelected = getState().main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: APP_PDC_URL + "/api/v1/surveys/drafts/" + id,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: draftsConstants.GET_DRAFT_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: draftsConstants.GET_DRAFT_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: draftsConstants.GET_DRAFT_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: draftsConstants.GET_DRAFT_ASK_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}

export function deleteDraftAsk(id) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    const companyUuidSelected = getState().main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "DELETE",
        url: APP_PDC_URL + "/api/v1/surveys/drafts/" + id,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: draftsConstants.DELETE_DRAFT_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: draftsConstants.DELETE_DRAFT_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: draftsConstants.DELETE_DRAFT_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: draftsConstants.DELETE_DRAFT_ASK_ERROR,
            error: response.toString()
          });
          reject(response);
        });
    });
  };
}
